import React, { useState } from 'react'
import axios from "axios"
import { useNavigate, Link } from 'react-router-dom'
import "./style/Login.css"

export default function Login() {

    const navigate = useNavigate()
    const api = "https://mkbackend-production.up.railway.app"
    
    const [form, setForm] = useState({
        email: "",
        password: ""
    })

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleLogin = async (e) => {
        e.preventDefault()

        try {
            const res = await axios.post(
                `${api}/login`,
                form
            )

            if (res.data.success) {
                localStorage.setItem("token", res.data.token)
                localStorage.setItem("shop", JSON.stringify(res.data.user))
                alert("Login Success")
                navigate("/profile")
            } else {
                alert(res.data.message)
            }
        } catch (err) {
            console.log(err)
            alert("Login failed. Please try again.")
        }
    }

    return (
        <div className='login'>

            <form onSubmit={handleLogin}>

                <input
                    type="email"
                    placeholder='Email'
                    name='email'
                    onChange={handleChange}
                    required
                />

                <input
                    type="password"
                    placeholder='Password'
                    name='password'
                    onChange={handleChange}
                    required
                />

                <button type="submit">
                    Login
                </button>

                {/* Forgot Password Link - MOVED INSIDE FORM */}
                <div className="forgot-password-link">
                    <Link to="/forgotpassword">Forgot Password?</Link>
                </div>

            </form>

            {/* Signup Link - OUTSIDE FORM */}
            <div className="signup-link">
                <Link to="/singup">Don't have an account? Sign Up</Link>
            </div>

        </div>
    )
}